import React, { useState } from 'react'
import './Contacto.css'
import Header from '../Header/Header'
import ContactoData from '../../Components/Admin/ContactoData/ContactoData'
import QuienesSomosData from '../../Components/Admin/QuienesSomosData/QuienesSomosData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressBook, faUsers } from '@fortawesome/free-solid-svg-icons'

export default function Contacto() {
    const [activeTab, setActiveTab] = useState('contacto'); // 'contacto' | 'quienesSomos'

    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    {/* Pestañas de navegación */}
                    <div className='contactoTabsNav'>
                        <button
                            type='button'
                            className={`contactoTabBtn ${activeTab === 'contacto' ? 'active' : ''}`}
                            onClick={() => setActiveTab('contacto')}
                        >
                            <FontAwesomeIcon icon={faAddressBook} /> Información de Contacto
                        </button>
                        <button
                            type='button'
                            className={`contactoTabBtn ${activeTab === 'quienesSomos' ? 'active' : ''}`}
                            onClick={() => setActiveTab('quienesSomos')}
                        >
                            <FontAwesomeIcon icon={faUsers} /> Quiénes Somos
                        </button>
                    </div>

                    {activeTab === 'contacto' ? (
                        <ContactoData />
                    ) : (
                        <QuienesSomosData />
                    )}
                </div>
            </section>
        </div>
    )
}


